/**
 * Masterpass isteklerinin `requestReferenceNumber` / `requestReferenceNo` alanı
 * için benzersiz referans üretir.
 *
 * ⚠️ Neden istemcide üretiliyor: eski akışta bu değer `RI.OnGenerateTLVToken`
 * cevabındaki `ReqRefNumber` alanından geliyordu. Yeni `RI.OnGenerateJwtoken`
 * servisinde o alan YOK; yerine yalnızca ödeme bağlamı gönderildiğinde dolan
 * `PaymentNumber` var. Kart ekleme gibi ödeme bağlamı olmayan işlemlerde
 * (ayrıca JWT önbelleğe alındığında servis hiç çağrılmadığı için) elde referans
 * kalmıyor ve Masterpass isteği `REQUEST_REFERENCE_NUMBER_IS_REQUIRED` ile
 * reddediyor.
 *
 * ⚠️ Servis tarafından üretilmiş bir referans VARSA (mobil akışın URL ile
 * geçtiği `reqRefNumber` ya da JWT cevabındaki `PaymentNumber`) o tercih
 * edilmelidir; bu fonksiyon yalnızca son çare olarak kullanılır.
 *
 * Biçim: `yyyyMMddHHmmss` + 4 haneli rastgele son ek = 18 haneli sayısal dizge.
 * SDK demoları bu alanı sayısal veriyor (`12345`, `213123213`); zaman damgası
 * aynı saniyedeki ardışık istekleri, rastgele son ek ise aynı saniyeye denk
 * gelen istekleri ayırır.
 */
const generateRequestReferenceNumber = (): string => {
  const now = new Date();
  const pad = (value: number, length = 2) => value.toString().padStart(length, '0');

  const timestamp = [
    now.getFullYear(),
    pad(now.getMonth() + 1),
    pad(now.getDate()),
    pad(now.getHours()),
    pad(now.getMinutes()),
    pad(now.getSeconds()),
  ].join('');

  const suffix = pad(Math.floor(Math.random() * 10000), 4);

  return `${timestamp}${suffix}`;
};

export default generateRequestReferenceNumber;
